<div ng-controller="LicenseController as licenseCtrl" class="modal-view ">
    <c-auto-form config="licenseCtrl.sheetProps"></c-auto-form>
</div>